<micro-lookup domain="ussd" obj="ussdSvcCodes" url="/ussdSvcCodes" [key]="ussdSvcCodeId"></micro-lookup>
